// extracted by mini-css-extract-plugin
module.exports = {"placeholderContainer":"styles_placeholderContainer__1ewFM","badge":"styles_badge__2UV9i"};